module.exports = __webpack_public_path__ + "img/020.1d73afb0.png";